var TITLE_SORT_STORAGE_PREFIX = 'pvTitleSort.';
export var clearRecekSessionStorage = function () {
    sessionStorage.removeItem('activeRoles');
    sessionStorage.removeItem('activeOrganization');
    sessionStorage.removeItem('activeLibrarySourceId');
    sessionStorage.removeItem('activeLibraryCanRequestCopies');
    sessionStorage.removeItem('viewAsLibraryId');
    sessionStorage.removeItem('viewAsLibraryName');
    Object.keys(sessionStorage)
        .filter(function (storageKey) { return storageKey.startsWith(TITLE_SORT_STORAGE_PREFIX); })
        .forEach(function (storageKey) { return sessionStorage.removeItem(storageKey); });
};
